import { Injectable, inject } from '@angular/core';
import {
    UserPositionDto,
    UserPositionExitCleanupTask,
} from '@pf/platform-core/domain';
import { PackingListDataService } from '@pf/platform-wms/domain';
import { asArraySafe } from '@pf/shared-utility';
import { Observable, of } from 'rxjs';
import { PackingContext } from '../../models/packing-context.model';
import { CpwUserPositionTypes } from '../../UserPositionTypes';

@Injectable({ providedIn: 'root' })
export class PackingPositionExitCleanupTask
    implements UserPositionExitCleanupTask
{
    readonly id = 'packing-unclaim';

    private readonly packingListDataService = inject(PackingListDataService);

    appliesTo(position: UserPositionDto): boolean {
        if (position.userPositionTypeName !== CpwUserPositionTypes.Packing) {
            return false;
        }
        const ctx = position.context as PackingContext | undefined;
        return !!asArraySafe(ctx?.packingListIds).length && !!ctx?.warehouseId;
    }

    cleanup$(position: UserPositionDto): Observable<unknown> {
        const ctx = position.context as PackingContext | undefined;
        const warehouseId = ctx?.warehouseId;
        const packingListIds = asArraySafe(ctx?.packingListIds);
        if (!warehouseId || !packingListIds.length) return of(null);
        return this.packingListDataService.unClaimPackingLists$(
            warehouseId,
            packingListIds
        );
    }
}
